import React, { useEffect } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";
import { Typography } from "@progress/kendo-react-common";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import ShadowCard from "../../../components/common/ShadowCard";
import FormDatePicker from "../../../components/formFields/FormDateField";
import moment from "moment";
import { getAllActiveUsers } from "../../user/services/user.services";
import { getAllRegions } from "../../region/services/region.services";
import { IRegion } from "../../region/regionModel";
import { ICountry } from "../../country/countryModel";
import { getAllActiveCountries } from "../../country/services/country.services";
import { getAllAgent } from "../../agent/services/agent.service";
import { IUser } from "../../user/userModel";
import { INQUIRYQUERIES } from "../../../_contstants/common";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const ChangeWatcher: React.FC<ChangeWatcherProps> = ({ formRenderProps }) => {
  useEffect(() => {
    formRenderProps.onChange("filterFromDate", {
      value: moment().startOf("month").toDate(),
    });
    formRenderProps.onChange("filterToDate", {
      value: moment().toDate(),
    });
  }, []);
  return null;
};

const DestinationWisePerformanceReportForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.reports.loading);
  const RegionList = useAppSelector((state) => state.region.RegionList);
  const CountryList = useAppSelector((state) => state.country.CountryList);
  // const AgentList = useAppSelector((state: RootState) => state.agent.AgentList);
  const UserList = useAppSelector((state) => state.user.UserList);

  useEffect(() => {
    dispatch(getAllRegions());
    dispatch(getAllActiveUsers());
    dispatch(getAllActiveCountries());
    dispatch(getAllAgent());
    dispatch(getAllActiveUsers());
  }, []);

  const handleSubmit = (values: any) => {
    const payload: any = {};

    payload.filterFromDate = values?.filterFromDate
      ? moment(values?.filterFromDate).format("YYYY-MM-DD")
      : "0";
    payload.filterToDate = values?.filterToDate
      ? moment(values?.filterToDate).format("YYYY-MM-DD")
      : "0";
    payload.RegionID = values?.RegionID ? values?.RegionID : "0";
    payload.CountryID = values?.CountryID ? values?.CountryID : "0";
    payload.RequirementType = values?.RequirementType
      ? values?.RequirementType
      : "0";
    payload.filterCreatedBy = values?.filterCreatedBy
      ? values?.filterCreatedBy
      : "0";

    window.open(
      `destinationwiseperformancereportview/${payload?.filterFromDate}/${payload?.filterToDate}/${payload?.RegionID}/${payload?.CountryID}/${payload?.filterCreatedBy}/${payload?.RequirementType}`
    );
  };

  return (
    <GridLayout gap={{ rows: 10 }} cols={[{ width: "100%" }]}>
      <GridLayoutItem>
        <ShadowCard>
          <Form
            onSubmit={handleSubmit}
            render={(formRenderProps: FormRenderProps) => (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ cols: 10, rows: 0 }}
                  cols={[{ width: "40%" }, { width: "30%" }, { width: "30%" }]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4
                      style={{ marginBottom: 0, marginLeft: "3px" }}
                    >
                      Destination Wise Performance Report
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      name="filterFromDate"
                      label="From Date"
                      format="dd/MM/yyyy"
                      wrapperStyle={{ width: "100%" }}
                      component={FormDatePicker}
                      astrike={true}
                      validator={requiredValidator}
                    />
                    <Field
                      name="filterToDate"
                      label="To Date"
                      format="dd/MM/yyyy"
                      minDate={moment(
                        formRenderProps.valueGetter("filterFromDate")
                      ).toDate()}
                      wrapperStyle={{ width: "100%" }}
                      component={FormDatePicker}
                      astrike={true}
                      validator={requiredValidator}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      name="RegionID"
                      wrapperClassName="w-50"
                      label="Region"
                      placeholder="Select Region"
                      component={FormSelectionField}
                      options={RegionList?.map((region: IRegion) => ({
                        value: region?.ID,
                        label: region?.RegionName,
                      }))}
                    />
                    <Field
                      id={"CountryID"}
                      name={"CountryID"}
                      label={"Country"}
                      wrapperClassName="w-50"
                      placeholder="i.e. India"
                      component={FormSelectionField}
                      options={CountryList?.map((country: ICountry) => {
                        return {
                          value: country?.ID,
                          label: country?.CountryName,
                        };
                      })}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem style={{ display: "flex", gap: 10 }}>
                    <Field
                      name="filterCreatedBy"
                      label="User"
                      placeholder="Select User"
                      wrapperClassName="w-50"
                      component={FormSelectionField}
                      options={UserList?.map((user: IUser) => ({
                        value: user?.ID,
                        label: `${user?.FirstName} ${user?.LastName}`,
                      }))}
                    />
                    <Field
                      name="RequirementType"
                      wrapperClassName="w-50"
                      label="Type"
                      placeholder="Type"
                      component={FormSelectionField}
                      options={INQUIRYQUERIES?.map((type: any) => ({
                        value: type?.value,
                        label: type?.label,
                      }))}
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  <GridLayoutItem
                    style={{
                      display: "flex",
                      gap: 10,
                      position: "relative",
                      minHeight: 50,
                    }}
                  >
                    <div style={{ position: "absolute", top: 20, right: 0 }}>
                      <ButtonWithLoading
                        label={"Get Details"}
                        type="submit"
                        Size="medium"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </div>
                  </GridLayoutItem>
                </GridLayout>
                <ChangeWatcher formRenderProps={formRenderProps} />
              </FormElement>
            )}
          />
        </ShadowCard>
      </GridLayoutItem>
    </GridLayout>
  );
};

export default DestinationWisePerformanceReportForm;
